import React from "react";
import { LoadingOutlined } from "@ant-design/icons";
import { Spin } from "antd";
import { useSelector } from "react-redux";

const CustomSpinner = ({ loading = false }) => {
  const collapsed = useSelector(
    (state) => state.settings_data?.isToggleSideMenu
  );
  if (!loading) return null; // Only render if loading is true

  return (
    <div
      style={{
        position: "fixed", // Ensure the spinner overlays the entire screen
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        zIndex: 999,
        backgroundColor: "rgba(0, 0, 0, 0.1)", // Optional: Add a semi-transparent background
        display: "flex", // Center the spinner
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Spin
        indicator={
          <LoadingOutlined
            spin
            style={{
              fontSize: "54px", // Make the spinner larger
              color: "#20c3ff", // Ensure good visibility
            }}
          />
        }
        size="large"
        style={{
          color: "#20c3ff",
          marginLeft: !collapsed ? 200 : 0, // Add margin-left if the side menu is collapsed
        }}
      />
    </div>
  );
};

export default CustomSpinner;
